export default "__VITE_ASSET__c9dad5e1__"